import { Component, input } from "@angular/core";
import { ClozeTestStyleModel } from '../model/cloze-test-style-model';
import { NgClass, NgStyle } from "@angular/common";

@Component({
  selector: "cloze-test-invalid-token",
  templateUrl: "./invalid-token.component.html",
  styleUrls: ["./invalid-token.component.scss"],
  standalone: true,
  imports: [NgClass, NgStyle],
})
export class InvalidTokenComponent {
  readonly clozeTestStyleModel = input({} as ClozeTestStyleModel);
  readonly mobileMode = input(false);
  readonly lang = input("de");
}
